import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { Action } from '../../actions';
import { fetchTooltipData } from '../../actions/grid-screen';
import { openHelp } from '../../actions/help';
import {
    HoverTooltipWrapper,
    HoverTooltipWrapperProps
} from '../../components/HoverTooltipWrapper/HoverTooltipWrapper';
import { DocCenterColumnTooltip, DocCenterTooltip, HelpLink } from '../../typings/doc-center';
import { State } from '../../typings/state';
// Список правильных линков ожидаем позже
// TODO: https://st.yandex-team.ru/DIRECT-82421
const moreLinks = {
    [DocCenterColumnTooltip.filter]: HelpLink.filter
    // [DocCenterColumnTooltip.campaignType]: HelpLink.campaignTypes,                        ;
    // [DocCenterColumnTooltip.shows]: HelpLink.shows,
    // [DocCenterColumnTooltip.ctr]: HelpLink.ctr,
    // [DocCenterColumnTooltip.clicks]: HelpLink.clicks,
    // [DocCenterColumnTooltip.goals]: HelpLink.avgGoalCost
};

type OwnProps = Pick<
    HoverTooltipWrapperProps,
    'id' | 'to' | 'header' | 'tooltipText' | 'cls' | 'theme' | 'view' | 'zIndexGroupLevel' | 'size'
>;

type StateProps = Pick<HoverTooltipWrapperProps, 'tooltipText' | 'moreLink'>;

type DispatchProps = Pick<HoverTooltipWrapperProps, 'onMouseEnter' | 'onMoreLinkClick'>;

const mapStateToProps = (state: State, ownProps: OwnProps): StateProps => {
    const { tooltips } = state.grid;
    const { id = '', tooltipText } = ownProps;
    return {
        tooltipText: tooltipText || tooltips[id],
        moreLink: moreLinks[id]
    };
};

const mapDispatchToProps = (dispatch: Dispatch<Action>): DispatchProps => {
    return {
        onMouseEnter: (id: DocCenterTooltip) => {
            dispatch(fetchTooltipData(id));
        },
        onMoreLinkClick: (link: HelpLink) => {
            dispatch(openHelp(link));
        }
    };
};

export const HoverTooltipContainer = connect<StateProps, DispatchProps, OwnProps>(
    mapStateToProps,
    mapDispatchToProps
)(HoverTooltipWrapper);
